import { ComponentFixture } from '@angular/core/testing';
import { DebugElement } from '@angular/core';
import { By } from '@angular/platform-browser';
export const typeInInput = (inputElement: HTMLInputElement, value: string, append = false) => {
  if (append) {
    inputElement.value = inputElement.value + value;
  } else {
    inputElement.value = value;
  }
  inputElement.dispatchEvent(new Event('input'));
};

export const getElementByCss = <T>(fixture: ComponentFixture<T>, selector: string, returnNativeElement = true) =>
  getNativeElement(fixture.debugElement.query(By.css(selector)), returnNativeElement);

const getNativeElement = (element: DebugElement, returnNativeElement: boolean) => {
  if (returnNativeElement) {
    return element ? element.nativeElement : undefined;
  }

  return element;
};
